import { AppMessages } from '../types';

export const pl: AppMessages = {
  languages: [
    { code: 'pl', label: 'Polski' },
    { code: 'en', label: 'English' },
    { code: 'de', label: 'Deutsch' },
    { code: 'ua', label: 'Українська' },
  ],
  nav: { home: 'Strona główna', study: 'Nauka', questionDemo: 'Podgląd pytania', exam: 'Egzamin' },
  userMenu: {
    settings: 'Ustawienia',
    status: 'Status',
    logout: 'Wyloguj się',
    anonymous: 'Niezalogowany',
    tierFree: 'Free',
    tierPremium: 'Premium',
    tierAdmin: 'Admin',
  },
  common: { loadingSession: 'Sprawdzanie sesji...', yes: 'Tak', no: 'Nie', days: 'dni' },
  landing: {
    eyebrow: 'Wszystkie kategorie egzaminu od 0,16 zł za dzień',
    title: 'Przygotuj się do prawa jazdy w tempie, które naprawdę pomaga zdać.',
    description: 'Ćwicz oficjalne pytania z filmami i zdjęciami, ucz się krótkimi seriami i sprawdzaj gotowość w egzaminie próbnym. Kategorie A, B, C, D, T i pozostałe masz dostępne w jednym miejscu.',
    primaryCta: 'Rozpocznij naukę',
    secondaryCta: 'Zobacz egzamin próbny',
    metricQuestions: 'pytań z katalogu',
    metricPriceValue: '0,16 zł',
    metricPrice: 'za dzień',
    metricCategoriesValue: 'pełny',
    metricCategories: 'zakres kategorii',
    heroAlt: 'Kursant rozwiązujący test na prawo jazdy online',
    featureOneTitle: 'Uczysz się tego, co daje wynik',
    featureOneText: 'Krótkie serie fiszek pomagają szybko wyłapać braki i wracać do pytań, które warto jeszcze przećwiczyć.',
    featureTwoTitle: 'Próba generalna przed WORD',
    featureTwoText: 'Rozwiązujesz testy w układzie egzaminacyjnym, z punktacją, historią wyników i mediami takimi jak w bazie pytań.',
    featureThreeTitle: 'Jedno konto na wszystkie kategorie',
    featureThreeText: 'Wybierasz kategorię egzaminu i możesz trenować pełny materiał dla motocykla, auta osobowego, ciężarówki lub autobusu.',
    proofTitle: 'Startujesz od darmowego konta, a pełny dostęp kosztuje grosze',
    proofText: 'Sprawdź naukę bez ryzyka, a gdy chcesz uczyć się bez ograniczeń, wybierz dostęp już od 0,16 zł za dzień. W pakiecie są wszystkie kategorie egzaminu i pełna baza pytań.',
    profileCta: 'Przejdź do profilu',
    createAccountCta: 'Załóż konto',
  },
  home: {
    title: 'Prawo Jazdy - Testy',
    signedIn: 'Zalogowano',
    username: 'Nazwa użytkownika',
    email: 'Email',
    noEmail: 'Brak emaila',
    providers: 'Dostawcy logowania',
    emailVerified: 'Email zweryfikowany',
    accountTier: 'Status konta',
    premiumUntil: 'Premium do',
    login: 'Zaloguj',
    register: 'Zarejestruj',
    logout: 'Wyloguj',
    emailOrUsername: 'Email lub nazwa użytkownika',
    password: 'Hasło',
    createAccount: 'Utwórz konto',
    pleaseWait: 'Proszę czekać...',
    authenticationFailed: 'Logowanie nie powiodło się.',
    or: 'lub',
    googleNotConfigured: 'Logowanie Google nie jest jeszcze skonfigurowane.',
    googleFailed: 'Logowanie Google nie powiodło się.',
    googleLoadFailed: 'Nie udało się załadować logowania Google.',
    usernamePlaceholder: 'Nazwa użytkownika',
    emailPlaceholder: 'Email',
    resendVerificationTitle: 'Wyślij ponownie email weryfikacyjny',
    accountEmail: 'Email konta',
    resendEmail: 'Wyślij ponownie',
    sending: 'Wysyłanie...',
    resetPasswordTitle: 'Reset hasła przez email',
    sendResetEmail: 'Wyślij reset hasła',
    changePasswordTitle: 'Zmień hasło',
    preferencesTitle: 'Preferencje nauki i egzaminu',
    savePreferences: 'Zapisz preferencje',
    preferencesSaved: 'Preferencje zostały zapisane.',
    preferencesFailed: 'Nie udało się zapisać preferencji.',
    currentPassword: 'Obecne hasło',
    newPassword: 'Nowe hasło',
    saving: 'Zapisywanie...',
    changePassword: 'Zmień hasło',
    changePasswordFailed: 'Nie udało się zmienić hasła.',
    deleteAccountTitle: 'Usuń konto',
    deleteAccountHint: 'Aby potwierdzić usunięcie, wpisz nazwę użytkownika. Konta lokalne wymagają też obecnego hasła.',
    usernameConfirmation: 'Potwierdzenie nazwy użytkownika',
    deleteAccount: 'Usuń konto',
    deleting: 'Usuwanie...',
    deleteAccountFailed: 'Nie udało się usunąć konta.',
    activatePremiumCode: 'Aktywuj kod Premium',
    premiumCodePlaceholder: 'Wpisz kod Premium',
    redeemCode: 'Aktywuj kod',
    redeeming: 'Aktywowanie...',
    premiumActiveUntil: 'Premium aktywne do',
    redeemFailed: 'Nie udało się aktywować kodu Premium.',
    generatePremiumCodes: 'Generuj kody Premium',
    generateCodes: 'Generuj kody',
    generating: 'Generowanie...',
    generateFailed: 'Nie udało się wygenerować kodów Premium.',
    alreadySignedInTitle: 'Jesteś zalogowany',
    alreadySignedInText: 'Możesz przejść do nauki albo profilu.',
    studyModeCta: 'Tryb nauki',
    profileCta: 'Profil',
    backToHome: 'Strona główna',
    signInTitle: 'Zaloguj się',
    createAccountTitle: 'Utwórz konto',
    authIntro: 'Jedno konto zapisuje kategorię egzaminu, język, postęp nauki i historię testów.',
    loginTab: 'Logowanie',
    registerTab: 'Rejestracja',
    resendVerificationLink: 'Wyślij ponownie link weryfikacyjny',
    forgotPassword: 'Zapomniałeś hasła?',
    profileLoginTitle: 'Profil użytkownika',
    profileLoginText: 'Zaloguj się, aby zarządzać kategorią egzaminu, językiem, kontem i statusem Premium.',
    premiumActive: 'Premium aktywne do',
    emailVerifiedShort: 'Email zweryfikowany',
    emailUnverifiedShort: 'Email niezweryfikowany',
    loginMethod: 'Logowanie',
  },
  verifyEmail: {
    title: 'Weryfikacja emaila',
    verifying: 'Weryfikowanie emaila...',
    incomplete: 'Link weryfikacyjny jest niekompletny.',
    failed: 'Nie udało się zweryfikować emaila.',
    backToSignIn: 'Wróć do logowania',
  },
  resetPassword: {
    title: 'Reset hasła',
    incomplete: 'Link resetu jest niekompletny.',
    failed: 'Nie udało się zresetować hasła.',
    setNewPassword: 'Ustaw nowe hasło',
    backToSignIn: 'Wróć do logowania',
  },
  notFound: {
    title: 'Nie znaleziono strony',
    text: 'Podany adres nie pasuje do żadnego ekranu aplikacji. Wróć na stronę główną albo otwórz jeden z dostępnych widoków.',
  },
  questionDemo: {
    pageTitle: 'Podgląd pytania',
    pageDescription: 'Wylosuj pytanie egzaminacyjne i sprawdź odpowiedź. Wybierz zakres, żeby ćwiczyć pytania podstawowe lub specjalistyczne.',
    loginRequired: 'Aby pobrać pytanie z backendu, zaloguj się na stronie głównej.',
    loading: 'Sprawdzanie sesji...',
    loadingCategories: 'Pobieranie kategorii...',
    loadQuestion: 'Pobierz inne pytanie',
    loadingQuestion: 'Pobieranie pytania...',
    languageLabel: 'Język',
    scopeLabel: 'Zakres',
    categoryLabel: 'Kategoria',
    scopeBasic: 'Podstawowy',
    scopeSpecialist: 'Specjalistyczny',
    fetchErrorFallback: 'Nie udało się pobrać pytania.',
    categoriesErrorFallback: 'Nie udało się pobrać kategorii.',
    publicPreviewNotice: 'Bez konta możesz zobaczyć 10 przykładowych pytań zapisanych lokalnie w aplikacji. Nie pobieramy ich z backendu.',
    publicPreviewLoading: 'Pobieranie darmowej puli 10 pytań...',
    publicPreviewSignupButton: 'Utwórz darmowe konto',
    signupModalTitle: 'To koniec darmowego podglądu',
    signupModalText: 'Aby kontynuować naukę i odblokować kolejne pytania, zaloguj się lub utwórz darmowe konto.',
    signupModalCreateAccount: 'Utwórz darmowe konto',
    signupModalLogin: 'Mam już konto',
    signupModalClose: 'Wróć do podglądu',
  },
  study: {
    title: 'Tryb nauki',
    description: 'Wybierz kategorię egzaminu i tag, a aplikacja będzie podawać fiszki zgodnie z Twoim postępem.',
    loginRequired: 'Aby rozpocząć naukę, zaloguj się na stronie głównej.',
    loading: 'Sprawdzanie sesji...',
    loadingCategories: 'Pobieranie kategorii i tagów...',
    languageLabel: 'Język',
    categoryLabel: 'Kategoria egzaminu',
    tagLabel: 'Tag pytań',
    chooseScopeTitle: 'Wybierz zakres nauki',
    allTags: 'Wszystkie tagi',
    start: 'Rozpocznij naukę',
    restart: 'Zacznij od nowa',
    loadingQuestions: 'Pobieranie pytań...',
    nextQuestion: 'Dalej',
    correct: 'Poprawna odpowiedź',
    incorrect: 'Niepoprawna odpowiedź',
    correctAnswer: 'Poprawna odpowiedź',
    progressCorrect: 'poprawnie',
    progressNotCorrect: 'nie',
    answered: 'Odpowiedziane',
    correctCount: 'Poprawne',
    remaining: 'W kolejce',
    noQuestionLoaded: 'Wybierz kategorię i rozpocznij naukę.',
    fetchErrorFallback: 'Nie udało się pobrać pytań do nauki.',
    categoriesErrorFallback: 'Nie udało się pobrać kategorii lub tagów.',
    submitErrorFallback: 'Nie udało się zapisać postępu.',
    mediaUnavailable: 'To pytanie nie ma mediów do wyświetlenia.',
    adTitle: 'Krótka przerwa reklamowa',
    adText: 'Użytkownicy Free widzą reklamę po każdych 12 pytaniach w trybie nauki.',
    adContinue: 'Kontynuuj naukę',
    adCountdown: 'Kontynuacja za',
  },
  exam: {
    title: 'Egzamin próbny',
    description: 'Po starcie pobierany jest pełny zestaw egzaminacyjny dla wybranej kategorii. Nie można wrócić do wcześniejszych pytań.',
    loginRequired: 'Aby rozpocząć egzamin, zaloguj się na stronie głównej.',
    loadingSession: 'Przygotowywanie egzaminu...',
    loadingCategories: 'Pobieranie kategorii...',
    languageLabel: 'Język',
    categoryLabel: 'Kategoria',
    startExam: 'Start testu',
    startingExam: 'Pobieranie pytań...',
    nextQuestion: 'Następne pytanie',
    finishExam: 'Zakończ i sprawdź wynik',
    questionCounter: 'Pytanie',
    globalTime: 'Czas całego testu',
    answeredCount: 'Odpowiedziane',
    remainingCount: 'Pozostałe',
    resultTitle: 'Wynik egzaminu',
    scoreLabel: 'Uzyskane punkty',
    maxScoreLabel: 'Maksymalna liczba punktów',
    passLabel: 'ZDANE',
    failLabel: 'NIEZDANE',
    passRule: 'Aby zdać, musisz uzyskać co najmniej 68 punktów.',
    fetchErrorFallback: 'Nie udało się pobrać zestawu egzaminacyjnego.',
    submitErrorFallback: 'Nie udało się sprawdzić wyniku egzaminu.',
    submitInProgress: 'Sprawdzanie wyniku...',
    noExamLoaded: 'Wybierz kategorię i kliknij start, aby pobrać zestaw egzaminacyjny.',
    categoriesErrorFallback: 'Nie udało się pobrać kategorii.',
    resultAdTitle: 'Zobacz wynik po reklamie',
    resultAdText: 'Użytkownicy Free widzą reklamę przed wynikiem egzaminu. Konto Premium wyłącza ten krok.',
    resultAdCountdown: 'Dostęp do wyniku za',
    resultAdContinue: 'Pokaż wynik',
    resultAdPremiumCta: 'Kup Premium',
    summaryTitle: 'Podsumowanie pytań',
    basicQuestionsTitle: 'Pytania podstawowe',
    specialistQuestionsTitle: 'Pytania specjalistyczne',
    correctAnswer: 'Poprawna odpowiedź',
    wrongAnswer: 'Niepoprawna odpowiedź',
    userAnswer: 'Twoja odpowiedź',
    expectedAnswer: 'Poprawna odpowiedź',
    unanswered: 'Brak odpowiedzi',
    testHistoryTitle: 'Historia testów',
    noTestHistory: 'Brak zapisanych testów.',
  },
  ads: {
    googleSlotTitle: 'Miejsce na reklamę Google',
    wideSkyscraperText: 'Miejsce na reklamę 160 x 600.',
    drivingOfferTitle: 'Oferta dla kierowców',
    secondSlotText: 'Miejsce na drugą reklamę 160 x 600.',
    roadSafetyTitle: 'Oferta bezpieczeństwa drogowego',
    drivingSchoolTitle: 'Reklama szkoły jazdy',
    examResultTitle: 'Reklama przed wynikiem',
    mediumRectangleText: 'Miejsce na reklamę 300 x 250.',
  },
  premium: {
    plansError: 'Nie udało się załadować planów. Spróbuj odświeżyć stronę.',
    checkoutError: 'Nie udało się rozpocząć płatności. Spróbuj ponownie.',
    loading: 'Ładowanie...',
    lead: 'Odblokuj pełny dostęp do historii egzaminów, trybu nauki bez reklam i wszystkich kategorii pytań.',
    activeBadge: 'Masz aktywne Premium',
    activeUntil: 'do',
    loadingPlans: 'Ładowanie planów...',
    popular: 'Najpopularniejszy',
    featureHistory: 'Pełna historia egzaminów',
    featureNoAds: 'Nauka bez reklam',
    featureAllCategories: 'Wszystkie kategorie pytań',
    featureBestDailyPrice: 'Najlepsza cena za dzień',
    redirecting: 'Przekierowuję...',
    buyNow: 'Kup teraz',
    loginToBuy: 'Zaloguj się, żeby kupić',
    stripeHintPrefix: 'Płatność obsługiwana przez',
    stripeHintSuffix: 'Środki pobierane są jednorazowo - brak subskrypcji.',
    successTitle: 'Płatność zakończona!',
    successText: 'Twoje konto zostało aktywowane. Premium jest już aktywne.',
    successHint: 'Jeśli premium nie widać jeszcze na koncie, odśwież stronę za chwilę - aktywacja zajmuje kilka sekund.',
    backHome: 'Wróć na stronę główną',
    cancelTitle: 'Płatność anulowana',
    cancelText: 'Nic nie zostało pobrane z Twojej karty.',
    backToPlans: 'Wróć do planów',
  },
  scopeLabels: { PODSTAWOWY: 'Podstawowy', SPECJALISTYCZNY: 'Specjalistyczny' },
  tagLabels: {
    'znaki-sygnaly': 'Znaki i sygnały drogowe',
    pierwszenstwo: 'Pierwszeństwo przejazdu',
    manewry: 'Manewry i zmiana kierunku',
    ostroznosc: 'Zachowanie ostrożności',
    'predkosc-odstepy': 'Prędkość i odstępy',
    'piesi-rowerzysci': 'Piesi, rowerzyści i przejścia',
    'skrzyzowania-pasy': 'Skrzyżowania i ruch na pasach',
    'parkowanie-zatrzymanie': 'Parkowanie i zatrzymanie',
    'warunki-jazdy': 'Warunki jazdy i widoczność',
    'stan-kierowcy': 'Stan kierowcy i bezpieczeństwo',
    'pojazd-dokumenty': 'Pojazd, wyposażenie i dokumenty',
    'transport-ladunek': 'Transport osób i ładunku',
    inne: 'Inne',
  },
};
